@if (iconPath()) {
  <svg class="icon" aria-hidden="true">
    <use [attr.href]="iconPath()" />
  </svg>
}
